  <div *ngIf="!groupNameDefined" class="input-group-sm mb-3">
    <label class="col-form-label d-block">
      {{ name }}<span *ngIf="required">*</span>
      <input  [type]="type"
              [formControl]="control"
              [readOnly]="readonly"
              [required]="required"
              [id]="formName"
              [name]="formName"
              [autofocus]="autofocus"
              [ngClass]="class"
              [style]="style"
              [attr.placeholder]="placeholder"/>

      <div *ngIf="control?.invalid && (control?.dirty || control?.touched)" class="mt-1 text-danger">
        <div *ngIf="control?.errors?.['required']">
          {{ name }} is required.
        </div>
        <div *ngIf="control?.errors?.['minlength']">
          {{ name }} min length is {{ control?.errors?.['minlength']?.requiredLength }}
        </div>
        <div *ngIf="control?.errors?.['maxlength']">
          {{ name }} max length is {{ control?.errors?.['maxlength']?.requiredLength }}
        </div>
      </div>
    </label>
  </div>
